import { render, staticRenderFns } from "./devMemo.vue?vue&type=template&id=d5c1dffa&scoped=true&"
import script from "./devMemo.vue?vue&type=script&lang=js&"
export * from "./devMemo.vue?vue&type=script&lang=js&"
import style0 from "./devMemo.vue?vue&type=style&index=0&id=d5c1dffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c1dffa",
  null
  
)

export default component.exports